import React from "react";
import style from "./index.module.scss";
import { StuVoteItem } from "service/vote";
import CustomEmpty from "components/CourseComponents/CustomEmpty";

interface StuListProps {
    data: StuVoteItem[];
}

export default function StuList({ data }: StuListProps) {
    return (
        <div className={style.root}>
            {data.map(item => (
                <div className={style.item} key={item.studentNo}>
                    <div className={style.name}>{item.name}</div>
                    <div className={style.stuNo}>{item.studentNo}</div>
                    {item.voteStatus === "1" && (
                        <div className={style.status}>已投票</div>
                    )}
                    {item.voteStatus !== "1" && (
                        <div className={style.statusEmpty}>--</div>
                    )}
                </div>
            ))}

            {data.length === 0 && <CustomEmpty />}
        </div>
    );
}
